import { PhoningMarkets } from './types';

export const marketCodeToLanguage = (marketCode: string): PhoningMarkets => {
    const mappingMarketLanguage: { [key: string]: PhoningMarkets } = {
        FR: 'fr',
        ES: 'es',
        IT: 'it',
        EN: 'en',
        DE: 'de',
        SE: 'se',
        DK: 'dk',
        NL: 'nl',
        CH: 'ch',
        CA: 'en',
        US: 'en',
        AT: 'at',
    };
    return mappingMarketLanguage[marketCode] || 'en';
};
